import React from 'react';

const FORM_URL =
  'https://forms.ministryforms.net/viewForm.aspx?formid=3536a780-f7bf-4d34-b173-b95181257285&direct-link=&embed=true&frameid=0924216788516562';

export default function Giving({ navigate }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

      {/* Banner: tell user which fund to pick */}
      <div style={{
        background: 'linear-gradient(135deg, #1a2c5b, #2a4080)',
        borderRadius: 12,
        padding: '12px 16px',
        marginBottom: 12,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
      }}>
        <span style={{ fontSize: '1.4rem' }}>👇</span>
        <div>
          <p style={{ color: 'white', fontWeight: 700, fontSize: '0.88rem', marginBottom: 2 }}>
            En el menú de fondos, selecciona:
          </p>
          <p style={{
            background: '#c9a84c',
            color: '#1a2c5b',
            fontWeight: 800,
            fontSize: '0.85rem',
            display: 'inline-block',
            padding: '2px 10px',
            borderRadius: 6,
          }}>
            Bethesda Espanol
          </p>
        </div>
      </div>

      {/* Embedded giving form */}
      <iframe
        src={FORM_URL}
        title="Dar - Bethesda Español"
        style={{
          width: '100%',
          flex: 1,
          minHeight: 'calc(100vh - 220px)',
          border: 'none',
          borderRadius: 12,
          background: 'white',
        }}
        allow="payment"
        scrolling="yes"
        sandbox="allow-forms allow-scripts allow-same-origin allow-popups"
      />
      {/* Privacy Policy */}
      <div style={{ textAlign: 'center', padding: '8px 0 4px' }}>
        <button
          onClick={() => navigate && navigate('privacy-policy')}
          style={{ background: 'none', border: 'none', color: '#aaa', fontSize: '0.75rem', cursor: 'pointer', textDecoration: 'underline' }}
        >
          Política de Privacidad
        </button>
      </div>
    </div>
  );
}
